<template>
  <div v-html="content">
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    content: {
      type: String,
      default: '',
    },
  },
});
</script>
